// removed by extract-text-webpack-plugin
module.exports = {"grid":"general__grid___tNY7l display-flex flexWrap-wrap"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-grid/Grid/style/general.css
// module id = 44
// module chunks = 0 1 6